import angular from 'angular';
import SearchFormComponent from './search-form/searchForm.component';
import VerticalTabComponent from './search-form/vertical-tab/verticalTab.component';
import VisualPickerComponent from './search-form/visual-picker/visualPicker.component';
import CheckboxesComponent from './search-form/checkboxes/checkboxes.component';
import ResultsSummaryComponent from './results-summary/results-summary.component';
import ResultComponent from './result/result.component';
import LoadingComponent from './loading/loading.component';
import SortByComponent from './sort-by/sort-by.component';
import DatePickerComponent from './date-picker/date-picker.component';
import AlertComponent from './alert/alert.component';
import PaginationComponent from './pagination/pagination.component';
import InformationPillComponent from './information-pill/information-pill.component';
import ContactExpertSuccessComponent from './contact-expert-success/contact-expert-sucess.component';
import SolutionLightboxComponent from './search-form/solution-lightbox/solutionLightbox.component';
import CloseablePillComponent from './closeable-pill/closeable-pill.component';

const ComponentModule = angular
  .module('components.expertFinder', [])
  .component('searchForm', SearchFormComponent)
  .component('verticalTab', VerticalTabComponent)
  .component('visualPicker', VisualPickerComponent)
  .component('checkboxes', CheckboxesComponent)
  .component('resultsSummary', ResultsSummaryComponent)
  .component('result', ResultComponent)
  .component('loading', LoadingComponent)
  .component('sortBy', SortByComponent)
  .component('datePicker', DatePickerComponent)
  .component('efAlert', AlertComponent)
  .component('pagination', PaginationComponent)
  .component('informationPill', InformationPillComponent)
  .component('contactExpertSuccess', ContactExpertSuccessComponent)
  .component('solutionLightbox', SolutionLightboxComponent)
  .component('closeablePill', CloseablePillComponent)
;
export default ComponentModule;




// WEBPACK FOOTER //
// ./src/components/index.js